var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Layout', {
    staticClass: "home-layout"
  }, [_c('Content', [_c('div', {
    staticClass: "home-form-container"
  }, [_c('div', {
    staticClass: "home-form-title text-center"
  }, [_vm._v("噢易云产品试用申请系统")]), _c('Form', {
    ref: "loginForm",
    staticClass: "home-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formRules,
      "autocomplete": "off",
      "showMessage": false
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "username",
      "label": "帐号："
    }
  }, [_c('IInput', {
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": _vm.loading,
      "autofocus": ""
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('username');
      },
      "on-enter": _vm.submit
    },
    model: {
      value: _vm.form.username,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "username", $$v);
      },
      expression: "form.username"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "ios-person-outline"
    },
    slot: "prepend"
  })], 1)], 1), _c('FormItem', {
    attrs: {
      "prop": "password",
      "label": "密码："
    }
  }, [_c('IInput', {
    attrs: {
      "type": "password",
      "placeholder": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('password');
      },
      "on-enter": _vm.submit
    },
    model: {
      value: _vm.form.password,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "ios-lock-outline"
    },
    slot: "prepend"
  })], 1)], 1), _c('div', {
    staticClass: "register-btn-wrap"
  }, [_c('a', {
    staticClass: "register-btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function click($event) {
        _vm.showRegisterModal = true;
      }
    }
  }, [_vm._v("新用户注册")])]), _c('Button', {
    attrs: {
      "type": "primary",
      "long": true,
      "disabled": !_vm.isFormValid,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("登录")])], 1)], 1), _c('div', {
    staticClass: "copyright-container"
  }, [_vm._v("Copyright © 2015-2020 武汉噢易云计算股份有限公司")]), _c('UserRegister', {
    attrs: {
      "title": "新用户注册"
    },
    model: {
      value: _vm.showRegisterModal,
      callback: function callback($$v) {
        _vm.showRegisterModal = $$v;
      },
      expression: "showRegisterModal"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };